import React, { useEffect, useState } from 'react'
import Statics from '../teacher/dashboard/Statics'
import SubjectList from '../teacher/dashboard/SubjectList'
import { Paper, Typography } from '@mui/material'
import { getTeacherStatics } from '../../services/statics/staticsService'
import { useSelector } from 'react-redux'

function TeacherDashBoard() {

  const [loading, setLoading] = useState(false)
  const [teacherStatics, setTeacherStatics] = useState({})
  const user = useSelector(state => state.userReducer.user);

  useEffect(() => {
    loadTeacherStatics()
  }, [])

  const loadTeacherStatics = async() => {
    if(loading) return;
    setLoading(true);

    try{
      const {myTeachers = []} = user;
      if(myTeachers.length === 0){
        console.log('No teacher found');
        return;
      }
      const {id: userId = -1} = myTeachers[0];
      const {status, data} = await getTeacherStatics(userId);
      if(status === 200){
        setTeacherStatics(data)
      }
    }catch(error){
      console.log(error)
    }finally{
      setLoading(false);
    }
  }
  

  return (
    <Paper>
      <Typography variant="h1" sx={{ padding: 2 , m : 1, textAlign: 'center'}}>
          Teacher Dashboard
        </Typography>

        <Statics   teacherStatics = {teacherStatics} />
        <SubjectList />
    </Paper>
  )
}

export default TeacherDashBoard